/**
 * Wrapper for DayPickerRangeController for consistent styling of month
 * navigation buttons
 */

import React from 'react';
import { DayPickerRangeController as ReactDayPickerRangeController } from 'react-dates';

import { PreviousMonthButton, NextMonthButton } from './CustomMonthNavigationButtons';

export default class DayPickerRangeController extends React.PureComponent {
    render() {
        return (
            <ReactDayPickerRangeController
                {...this.props}
                hideKeyboardShortcutsPanel
                noBorder
                navPrev={<PreviousMonthButton />}
                navNext={<NextMonthButton />} />
        );
    }
}
